<template>
    <b-modal id="modalProduct" :title="$t(`${product.title}`)" modal-class="custom-dialog dialog-1200"
    ok-only no-close-on-esc no-close-on-backdrop centered hide-footer :ok-disabled="loading">
        <div class="col-sm-12">
          <component
            :is="currentProduct"
            ref="componentInfoProduct"
            v-bind="extraProps"
            @requestComplementaryProduct="requestComplementaryProduct"
          />
        </div>
    </b-modal>
</template>

<script>
import WhatsApp from '@/views/modules/whatsapp/WhatsApp.vue'
export default {
  props: ['product'],
  name:'modalWs',
  components: {
    WhatsApp
  },
  computed: {
    currentProduct() {
      const products = {
        WhatsApp: 1
      }
      const productEntry = Object.entries(products).find(([product, id]) =>
        id === this.product.id
      )
      return productEntry ? this.$options.components[productEntry[0]] : null
    },
    extraProps() {
      return {
        onlyRequest: this.shouldOnlyRequest()
      }
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    shouldOnlyRequest () {
      return this.product.id === 1
    },
    requestComplementaryProduct () {
      this.$emit('requestComplementaryProduct', this.product)
    }
  }
}
</script>

<style>
</style>